import MessagePanel from "../framework/component/container/MessagePanel";
import React from "react";

// Constants to store the URL links for the application forms
const DATA_ONLY_URL = "/ams/resApplications/data-only";
const SAMPLES_AND_DATA_URL = "/ams/resApplications/samples-data";

// Help links
const APPLICATION_USER_GUIDE_URL = "https://community.ukbiobank.ac.uk/hc/en-gb/articles/28027357937053-AMS-User-Guide-Applying-for-Access";
const SAMPLE_POLICY_URL = "https://community.ukbiobank.ac.uk/hc/en-gb/article_attachments/24842962801565";

/**
 * This component is the screen where the researcher selects which type of application they are trying to submit
 * @constructor
 */
export default function ApplicationTypeSelect() {
  return <div className={"content-area menu-page"}>
    <h1>Application Type</h1>
    <MessagePanel title={"Data only application"}>
      If you wish to access UK Biobank data only, complete the form and select the tier of data you wish to access.
      Please see the AMS <a href={APPLICATION_USER_GUIDE_URL} target="_blank">Application User Guide</a> for further
      guidance.
    </MessagePanel>
    <div id={"dataOnlyBtnArea"} className={"btnArea"}>
      <a id="dataOnlyBtn" href={DATA_ONLY_URL} className="btn btn-primary">Data only application</a>
    </div>
    <MessagePanel title={"Samples and data application"}>
      <p>Please refer to our <a href={SAMPLE_POLICY_URL} target="blank">sample policy</a> that provides guidelines for
        researchers when making an application for the release of UK Biobank samples.</p>
      <p><b>Please contact the Access team before proceeding with a sample application submission.</b></p>
    </MessagePanel>
    <div id={"samplesAndDataBtnArea"} className={"btnArea"}>
      <a id="samplesAndDataBtn" href={SAMPLES_AND_DATA_URL} className="btn btn-primary">Samples and data application</a>
    </div>
  </div>;
}